import { render } from "./ContactGroup.vue?vue&type=template&id=0efd17e3&scoped=true&ts=true"
import script from "./ContactGroup.vue?vue&type=script&lang=ts"
export * from "./ContactGroup.vue?vue&type=script&lang=ts"

import "./ContactGroup.vue?vue&type=style&index=0&id=0efd17e3&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0efd17e3"]])

export default __exports__